import { ReactNode, ComponentProps, useState } from 'react';
import { Collapse } from '@mui/material';
import { AgSwitch } from 'app/agriculture/components/AgSwitch/AgSwitch';
import './ListGroup.scss';
import { AgExpandIconButton } from 'app/agriculture/infobox/common/AgExpandIcon/AgExpandIcon';

interface ListGroupProps {
    title: string;
    subtitle?: string;
    icon?: ReactNode;
    startExpanded?: boolean;
    children: ReactNode;
    switchProps?: ComponentProps<typeof AgSwitch>;
}

/* A ListGroup is an item in a grouped list. It contains a list of items, but is itself an item in a list of other ListGroups */
export function ListGroup({
    title,
    subtitle,
    icon,
    children,
    switchProps,
    startExpanded = false,
}: ListGroupProps) {
    const [expanded, setExpanded] = useState(startExpanded);

    return (
        <div className="ListGroup" data-testid="ListGroup">
            <div className="ListGroup__header">
                {icon != null && <div className="ListGroup__icon">{icon}</div>}
                <div className="ListGroup__title-container">
                    <h4 className="ListGroup__title">{title}</h4>
                    {subtitle == null ? null : (
                        <label className="ListGroup__subtitle">{subtitle}</label>
                    )}
                </div>
                {switchProps != null && (
                    <Collapse in={expanded} orientation="horizontal">
                        <div className="ListGroup__switch">
                            <AgSwitch {...switchProps} />
                        </div>
                    </Collapse>
                )}
                <div className="ListGroup__button">
                    <AgExpandIconButton
                        variant="outlined"
                        expanded={expanded}
                        onClick={() => {
                            setExpanded(!expanded);
                        }}
                    />
                </div>
            </div>
            <Collapse in={expanded}>
                <div className="ListGroup__content">{children}</div>
            </Collapse>
        </div>
    );
}
